import { addReferenceTitle, referenceListing } from "./referenceListing";
import stringSimilarity from "string-similarity";

const icons = {
  switch: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-switch-vertical">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M3 8l4 -4l4 4" />
      <path d="M7 4l0 9" />
      <path d="M13 16l4 4l4 -4" />
      <path d="M17 10l0 10" />
    </svg>`,

  edit: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-edit">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"/>
      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"/>
      <path d="M16 5l3 3"/>
    </svg>`,

  add: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-plus">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 5l0 14" />
      <path d="M5 12l14 0" />
    </svg>`,

  delete: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
      class="icon icon-tabler icons-tabler-outline icon-tabler-trash">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M4 7l16 0" />
      <path d="M10 11l0 6" />
      <path d="M14 11l0 6" />
      <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
    </svg>`,
  toggle: `<svg  xmlns="http://www.w3.org/2000/svg"  width="16"  height="16"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-chevron-down"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 9l6 6l6 -6" /></svg>`,
  move: `<svg  xmlns="http://www.w3.org/2000/svg"  width="16"  height="16"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-replace"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M15 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" /><path d="M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3" /><path d="M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3" /></svg>`,
};

function createSvgButton(editor, { type, edit, svg }) {
  return editor.dom.create(
    "button",
    {
      type: "button",
      "data-btn-type": type,
      "data-edit": edit,
    },
    svg
  );
}


function insertButtonsInWrapper(editor, refHeadNode, ...buttons) {
  if (!refHeadNode) return;

  const wrapperDiv = editor.dom.create("div", { "data-edit": "refWrapper" });
  buttons.forEach((btn) => {
    if (!btn) return;

    editor.dom.add(wrapperDiv, btn);

  
  });

  editor.dom.add(refHeadNode, wrapperDiv);
}

function attachClickAndLongPress(
  button,
  { onClick, onLongPress, threshold = 500 }
) {
  if (button._eventsAttached) return; // already attached

  let pressTimer = null;

  const startPress = () => {
    pressTimer = setTimeout(() => {
      if (typeof onLongPress === "function") onLongPress();
      pressTimer = null;
    }, threshold);
  };

  const endPress = () => {
    if (pressTimer) {
      clearTimeout(pressTimer);
      if (typeof onClick === "function") onClick();
    }
  };

  button.addEventListener("mousedown", startPress);
  button.addEventListener("mouseup", endPress);
  button.addEventListener("mouseleave", () => clearTimeout(pressTimer));
  button.addEventListener("touchstart", startPress);
  button.addEventListener("touchend", endPress);
  button.addEventListener("touchcancel", () => clearTimeout(pressTimer));

  button._eventsAttached = true; // mark as attached
}

function moveRefAfterNextRef(editor, button, setShowReference) {
  setShowReference((prev) => ({
    ...prev,
    swap: {
      open: true,
      edit: false,
      id: null,
    },
  }));
  const ref = editor.dom.getParent(button, "ref");
  const nextRef = editor.dom.getNext(ref, "ref");

  if (ref && nextRef) {
    editor.dom.insertAfter(ref, nextRef);
    referenceListing(editor);
    addReferenceTitle(editor);
  }
}

function swapRefsById(editor, fromId, toId, setShowReference) {
  const refId = `ref-${toId}`;
  const fromRef = editor.dom.get(fromId);
  const toRef = editor.dom.get(refId);

  if (!fromRef || !toRef || fromRef === toRef) return;

  const parent = fromRef.parentNode;

  // Insert a temporary placeholder
  const placeholder = document.createElement("div");
  parent.insertBefore(placeholder, fromRef);

  // Swap nodes using the placeholder
  parent.replaceChild(fromRef, toRef);
  parent.replaceChild(toRef, placeholder);

  // Clean up placeholder
  placeholder.remove();

  // Optional: re-run any sync functions
  referenceListing(editor);
  addReferenceTitle(editor);
}
function moveRefToTarget(editor, fromId, toId, setShowReference) {
  const fromRef = editor.dom.get(fromId);
  const targetRef = editor.dom.get(`ref-${toId}`);

  if (!fromRef || !targetRef || fromRef === targetRef) return;
  const parent = targetRef.parentNode;
  // Move `fromRef` after `targetRef`
  if (toId === "1" || toId === 1) {
    parent.insertBefore(fromRef, targetRef);
  } else {
    // Move AFTER the targetRef
    editor.dom.insertAfter(fromRef, targetRef);
  }

  referenceListing(editor);
  addReferenceTitle(editor);
}
const getTextWithQueryDisplayed = (element) => {
  if (!element) return "";

  const texts = [];
  element.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      texts.push(node.textContent.trim());
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      if (node.tagName.toLowerCase() === "query") {
        texts.push(node.outerHTML); // Keeps <query> as tag
        // Or use: texts.push(`[Query: ${node.textContent}]`);
      } else {
        texts.push(getTextWithQueryDisplayed(node));
      }
    }
  });

  return texts.join(" ").replace(/\s+/g, " ").trim();
};

const getTextWithoutQuery = (element) => {
  if (!element) return "";

  const texts = [];
  element.childNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      texts.push(node.textContent.trim());
    } else if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName.toLowerCase() !== "query"
    ) {
      texts.push(getTextWithoutQuery(node));
    }
  });

  return texts.join(" ").replace(/\s+/g, " ").trim();
};

function getDuplicateRefs(editor, threshold = 0.7) {
  const normalize = (str) =>
    str
      .normalize("NFKD")
      .toLowerCase()
      .replace(/[\W_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const allRefs = editor.dom.select("ref");

  const refData = allRefs
    .map((ref) => {
      const id = ref.getAttribute("id");
      const refOutput = editor.dom.select("refoutput", ref)[0];
      if (!id || !refOutput) return null;

      const compareText = normalize(getTextWithoutQuery(refOutput));
      const displayText = getTextWithQueryDisplayed(refOutput);

      return { id, text: compareText, displayText };
    })
    .filter(Boolean);

  const grouped = [];
  const seen = new Set();

  for (let i = 0; i < refData.length; i++) {
    if (seen.has(refData[i].id)) continue;

    const group = [refData[i]];

    for (let j = 0; j < refData.length; j++) {
      if (i !== j && !seen.has(refData[j].id)) {
        const sim = stringSimilarity.compareTwoStrings(
          refData[i].text,
          refData[j].text
        );
        if (sim >= threshold) {
          group.push(refData[j]);
          seen.add(refData[j].id);
        }
      }
    }

    if (group.length > 1) {
      seen.add(refData[i].id);
      grouped.push(group);
    }
  }

  return grouped;
}

const getAllRefLength = (editor) => {
  const allRefs = editor?.dom?.select("ref");

  return allRefs?.length ?? 0;
};

function contribIdTagCheck(editor) {
  if (!editor.dom) return;

  const contribGroups = editor.dom.select("contrib-group");

  contribGroups.forEach((group) => {
    const contribIds = group.querySelectorAll("contrib-id");

    contribIds.forEach((contrib) => {
      const children = Array.from(contrib.childNodes);

      if (!contrib.innerHTML.trim()) {
        const newContrib = document.createElement("contrib-id");
        for (let attr of contrib.attributes) {
          newContrib.setAttribute(attr.name, attr.value);
        }
        contrib.replaceWith(newContrib);
        contrib = newContrib;
      }

      const elementChildren = children.filter(
        (node) => node.nodeType === Node.ELEMENT_NODE
      );

      if (elementChildren.length > 0) {
        const parent = contrib.parentNode;
        const fragment = document.createDocumentFragment();

        elementChildren.forEach((child) => {
          fragment.appendChild(child);
        });

        parent.insertBefore(fragment, contrib.nextSibling);
      }
    });
  });
}

export {
  icons,
  attachClickAndLongPress,
  moveRefAfterNextRef,
  insertButtonsInWrapper,
  createSvgButton,
  getDuplicateRefs,
  swapRefsById,
  moveRefToTarget,
  getAllRefLength,
  contribIdTagCheck,
};
